import { formatNumber } from "@/utilities/formatNumber";

/**
 * The number formatter the report grids use in their `valueFormatter`.
 *
 * Every measurement column on all three views formats the same way — two decimals by default,
 * the unit named in the header rather than repeated in the cell — so the closure is built once
 * per language instead of once per column hook.
 *
 * @param language - The language to format for.
 */
export function decimalFormatter(language: string) {
  return (value: number | null, precision = 2) => formatNumber(value, language, precision);
}
